import useSWRImmutable from 'swr/immutable';
import { QueryKey } from '@/api/queryKey';
import { getOwnSchoolGroup } from '@/api/schoolGroup';

export const useOwnSchoolGroupByUserId = () => {
  const { data, isLoading, isValidating, error, mutate } = useSWRImmutable(
    () => QueryKey.GetOwnSchoolGroup(),
    () => getOwnSchoolGroup()
  );

  return {
    data: data ?? null,
    isLoading,
    isValidating,
    isReady: !isLoading && !isValidating && !error,
    error,
    mutate,
  };
};
